import FluxUtils from 'flux/utils';

import SettingsStore from 'sharedreact/stores/SettingsStore';
import { assertNonNullish } from 'sharedreact/utils/TypeSupport';

import AdminStatusbar from 'workspaces/launcher/components/admin/AdminStatusbar';
import AgentsStore from 'workspaces/launcher/stores/AgentsStore';
import AuditStore from 'workspaces/launcher/stores/AuditStore';
import FontsStore from 'workspaces/launcher/stores/FontsStore';
import TokensStore from 'workspaces/launcher/stores/TokensStore';
import ViewSessionsStore from 'workspaces/launcher/stores/ViewSessionsStore';
import asFunctional from 'sharedreact/components/asFunctional';

type Props = {
  tab: string
};

type State = ConstructorParameters<typeof AdminStatusbar>[0];

function getStores () {
  return [
    SettingsStore,
    FontsStore,
    ViewSessionsStore,
    AgentsStore,
    TokensStore,
    AuditStore
  ];
}

function calculateState (prevState?: State, props?: Props): State {
  assertNonNullish(props);

  let allowMultiSelect: boolean = false;
  let nrOfItemsSelected: number = 0;
  let nrOfItems: number = 0;
  let stringPrefix: string = '';

  if (props.tab === 'managefonts') {
    allowMultiSelect = FontsStore.getAllowMultiSelect();
    nrOfItemsSelected = FontsStore.getSelection().size;
    nrOfItems = FontsStore.getItems().size;
    stringPrefix = 'launcher.admin.fonts';
  } else if (props.tab === 'viewsessions') {
    nrOfItems = ViewSessionsStore.getMaxSessions();
    nrOfItemsSelected = ViewSessionsStore.getTotalNumberOfItems();
    allowMultiSelect = true;        // fake to force showing max number of sessions
    if ((nrOfItems === null) || (nrOfItems < 0)) {
      // failed to get maximum number of sessions
      nrOfItems = 0;
      nrOfItemsSelected = 0;
    }
    stringPrefix = 'launcher.admin.viewsessions';
  } else if (props.tab === 'managetokens') {
    nrOfItems = TokensStore.getItems().size;
    nrOfItemsSelected = 0;
    stringPrefix = 'launcher.admin.tokens';
  } else if (props.tab === 'manageagents') {
    nrOfItems = AgentsStore.getItems().size;
    nrOfItemsSelected = 0;
    stringPrefix = 'launcher.admin.agents';
  } else if (props.tab === 'audit') {
    nrOfItems = AuditStore.getItems().size;
    nrOfItemsSelected = 0;
    stringPrefix = 'launcher.admin.audit';
  } 

  return {
    language: SettingsStore.getLanguage(),
    allowMultiSelect: allowMultiSelect,
    nrOfItemsSelected: nrOfItemsSelected,
    nrOfItems: nrOfItems,
    stringPrefix: stringPrefix
  };
}

export default FluxUtils.Container.createFunctional(
  asFunctional(AdminStatusbar),
  getStores,
  calculateState,
  { withProps: true }
);
